<script lang="ts">
  import { upperCase } from "lodash-es";
  import { getEnvironmentFromHostname } from "utils/fns";
  import { getBildebankenHost } from "../config";

  export let onClickTitle: (event: MouseEvent) => void = () => {
    window.location.assign(getBildebankenHost().href);
  };

  const onClickHeader = () => {
    alert(
      "Takk for at du prøver ut Bildebanken! ♥ \n\nKom gjerne med tilbakemeldinger og innspill på #️⃣bildebanken på Slack. 🐧",
    );
  };

  const environment = getEnvironmentFromHostname(getBildebankenHost().hostname);

  const environmentColors = {
    dev: "--nrk-color-warm-mint-600",
    stage: "--nrk-color-warm-orange-600",
    beta: "--nrk-color-core-blue-600",
    pr: "--nrk-color-warm-orange-600",
  };
</script>

<header>
  <h1>
    {#if environment !== "prod"}
      <div class="banner" style={`background: var(${environmentColors[environment]})`}>
        <button class="reset" on:click|preventDefault={onClickHeader}>
          {upperCase(environment)}
        </button>
      </div>
    {/if}
    <button class="reset header title" on:click={onClickTitle} data-testid="header-logo-clear-button">Bildebanken</button>
  </h1>
  <slot />
</header>

<style>
  header {
    justify-content: space-between;
    background-color: var(--bb-tile-bg-color);
    border-bottom: 0.5px solid var(--color-surface-primary);
    color: var(--color-text-primary);
    display: flex;
    align-items: center;
    height: 50px;
    padding: 28px var(--org-medium);
    margin: 0;
  }

  @media (max-width: 768px) {
    header {
      flex-wrap: wrap;
      height: auto;
      padding: 0 var(--org-medium);
    }

    header h1 {
      margin-bottom: 0;
      margin-top: 4px;
    }
  }

  .title,
  .title:hover {
    text-decoration: none;
  }

  .banner {
    position: absolute;
    font-size: 0.8rem;
    rotate: -50deg;
    width: 80px;
    height: 19px;
    text-align: center;
    top: 6px;
    left: -25px;
    transition: 0.35s;
  }

  .banner:hover {
    scale: 1.5;
    rotate: -40deg;
    transition: 1.2s;
  }

  .banner button {
    cursor: help;
    color: white;
    font-weight: normal;
  }

  .reset {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0;
    background: none;
    border: none;
    font-weight: 600;
    padding: 0;
  }

   .header {
    cursor: pointer;
   }
</style>
